export const t_global_icon_color_status_warning_default = {
  "name": "--pf-t--global--icon--color--status--warning--default",
  "value": "#dca614",
  "var": "var(--pf-t--global--icon--color--status--warning--default)"
};
export default t_global_icon_color_status_warning_default;